import { render, staticRenderFns } from "./RegularLineList.vue?vue&type=template&id=88b048b0"
import script from "./RegularLineList.vue?vue&type=script&lang=js"
export * from "./RegularLineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports